// 在request.js中引入axios
import Vue from 'vue'
import Router from '../src/router'
import axios from 'axios'
import QS from 'qs' // 用来序列化post类型的数据
import { Message } from 'element-ui'
// 访问域名
let baseURL = ''
if (window.location.href.indexOf('beta') != -1) {
    baseURL = 'https://spotlight-beta.istarshine.com/'
} else if (window.location.href.indexOf('spotlight.istarshine.com') != -1) {
    baseURL = 'https://spotlight.istarshine.com/'
} else {
    baseURL = 'https://spotlight-alpha.istarshine.com/'
}
const instance1 = axios.create({
    baseURL,
    timeout: 60000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})
const instance2 = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})
//H5 报告预览项目部署的域名
window.sessionStorage.setItem('baseURL', baseURL)

// 请求拦截器
instance1.interceptors.request.use(
    config => {
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

/**
 * 把非标准响应（网关/容器直接返回的 HTML、空响应等）包装成前端统一的 { header: { status, msg } } 结构，
 * 避免真实失败原因被兜底文案「服务器异常」吞掉。
 */
/**
 * 孤立代理项（lone surrogate）= 半个 emoji。
 * 富文本编辑里删除 emoji 时，若编辑器按 UTF-16 单元而非码点处理，就会残留半个代理对；
 * 不同浏览器的处理方式不一致，所以同样的操作有人能存、有人不能。
 * 这种字符无法通过 encodeURIComponent，会让 QS.stringify 抛 URIError，请求根本发不出去。
 */
const LONE_HIGH_SURROGATE = /[\uD800-\uDBFF](?![\uDC00-\uDFFF])/g
const LONE_LOW_SURROGATE = /(^|[^\uD800-\uDBFF])([\uDC00-\uDFFF])/g

function stripLoneSurrogates(str) {
    // 只移除落单的半个代理对，完整的 emoji（含 ZWJ 组合）不受影响
    return str.replace(LONE_HIGH_SURROGATE, '').replace(LONE_LOW_SURROGATE, '$1')
}

function sanitizeDeep(value, depth) {
    depth = depth || 0
    if (depth > 10) return value
    if (typeof value === 'string') return stripLoneSurrogates(value)
    if (Array.isArray(value)) return value.map(v => sanitizeDeep(v, depth + 1))
    if (value && typeof value === 'object') {
        const out = {}
        Object.keys(value).forEach(k => {
            out[k] = sanitizeDeep(value[k], depth + 1)
        })
        return out
    }
    return value
}

/**
 * 正常情况下直接序列化，零额外开销；仅当编码失败时才清理损坏字符后重试，
 * 避免把「请求发不出去」这种失败伪装成服务端错误。
 */
function safeStringify(params) {
    try {
        return QS.stringify(params)
    } catch (e) {
        if (e instanceof URIError) {
            try {
                const result = QS.stringify(sanitizeDeep(params))
                console.warn('[request] 提交内容中存在不完整的表情符号字符，已自动清除后提交')
                return result
            } catch (e2) {
                const err = new Error('提交内容中存在无法识别的特殊字符，请删除最近粘贴或编辑的表情符号后重试')
                err.name = 'ContentEncodeError'
                throw err
            }
        }
        throw e
    }
}

function normalizeError(response, badFormat) {
    const httpStatus = response && response.status
    const statusMsgMap = {
        400: '请求被服务器拒绝(400)，通常是提交内容过大或参数格式非法',
        401: '未授权(401)',
        403: '没有访问权限(403)',
        404: '接口不存在(404)',
        413: '提交内容过大(413)，已被网关拒绝',
        500: '服务内部错误(500)',
        502: '网关错误(502)，服务可能正在重启',
        503: '服务不可用(503)',
        504: '网关超时(504)，请求处理时间过长'
    }
    let msg
    if (badFormat) {
        // HTTP 本身成功，但响应体不是约定的 JsonResponse，常见于网关返回 HTML 错误页或登录页
        msg = `服务返回了非预期的响应格式(HTTP ${httpStatus})，请求可能被网关拦截`
    } else {
        msg = statusMsgMap[httpStatus] || `请求失败(HTTP ${httpStatus})`
    }
    // 以 axios response 为基础追加 header，保证既有读取 err.data / err.status 的调用方不受影响
    return Object.assign({}, response, { header: { status: httpStatus, msg: msg } })
}

// 响应拦截器
instance1.interceptors.response.use(
    response => {
        const payload = response.data
        if (payload && typeof payload.body == 'string') {
            return payload
        }
        if (!payload || typeof payload != 'object' || !payload.header) {
            // 响应体不是约定的 JsonResponse 结构，按 HTTP 状态码给出可读提示，
            // 否则下面读 payload.header.status 会抛 TypeError，真实原因就丢了
            return Promise.reject(normalizeError(response, true))
        }
        if (payload.header.status == 200) {
            return payload.body
        } else if (payload.header.status == 400) {
            // session 过期，跳转登录页
            if (process.env.NODE_ENV == 'development') {
                // 本地开发环境不跳转
                return Promise.reject(payload)
            }
            Vue.$cookies.remove('4b25a36bac7956242a5c170c78339461')
            Vue.$cookies.remove('user_info')
            if (Router.currentRoute.path !== '/login') {
                Router.push({ path: '/login' })
            }
            return Promise.reject(payload)
        } else if (payload.header.status == 401) {
            let errMsg = '当前用户没有权限' // (response.data.header && response.data.header.msg) ||
            Message.error(errMsg)
            return response
        } else {
            return Promise.reject(payload)
        }
    },
    // 服务器状态码不是200的情况
    error => {
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        const res = error.response
        if (!res) {
            // 网络中断、请求超时、请求被取消，此时没有响应对象
            return Promise.reject({ header: { status: -1, msg: error.message || '网络请求失败' } })
        }
        if (res.data && res.data.header) {
            // 后端返回了标准结构，保留 axios response 原有字段，仅把 header 提到顶层
            return Promise.reject(Object.assign({}, res, { header: res.data.header }))
        }
        return Promise.reject(normalizeError(res, false))
    }
)

/**
 * 本地调试时，处理权限验证问题;
 * 添加调试参数 debug=true&aid=4
 * @param params
 * @returns {*}
 */
function handleParams(params) {
    if (process.env.NODE_ENV == 'development') {
        if (Object.prototype.toString.call(params) === '[object Object]') {
            params = params || {}
            params.debug = true
            params.debugMobile = 15210351071
        } else {
            if (params == undefined || params.toString().indexOf('?') == -1) {
                params = params + '?debug=true&debugMobile=15210351071'
            } else {
                params = params + '&debug=true&debugMobile=15210351071'
            }
        }
    }
    return params
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .get(url, {
                params: handleParams(params)
            })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function get2(url, params) {
    return new Promise((resolve, reject) => {
        instance2
            .get(url, {
                params: handleParams(params)
            })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export function getForGpt(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .get(url, {
                timeout: 60000,
                params: handleParams(params)
            })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export function getDelay(url, params, timeout = 15000, cancelToken = null) {
    return new Promise((resolve, reject) => {
        instance1
            .get(url, {
                timeout: timeout,
                params: handleParams(params),
                cancelToken: cancelToken
            })
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export function getEncode(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .get(url, {
                params: params instanceof URLSearchParams ? params : handleParams(params)
            })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * getId方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function getId(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .get(url + handleParams(params))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
/**
 * postId方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postId(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .post(url + handleParams(params))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .post(url, safeStringify(handleParams(params)))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function postDelay(url, params, timeout = 15000, cancelToken = null) {
    return new Promise((resolve, reject) => {
        instance1
            .post(url, safeStringify(handleParams(params)), {
                timeout: timeout,
                cancelToken: cancelToken
            })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function post2(url, params) {
    return new Promise((resolve, reject) => {
        instance2
            .post(url, safeStringify(handleParams(params)))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function postForGpt(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .create({
                baseURL,
                timeout: 60000,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .post(url, safeStringify(handleParams(params)))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * postBody，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postBody(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .post(url, { data: handleParams(params) })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .put(url, safeStringify(handleParams(params)))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * putBody方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function putBody(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .put(url, { data: handleParams(params) })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * del方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function del(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .delete(url, { params: handleParams(params) })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * del方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function delDirect(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .delete(url + handleParams(params))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * delBody方法，对应deleteBody请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function delBody(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .delete(url, { data: handleParams(params) })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function fileGet(url, params, config) {
    return instance2.get(url, Object.assign({params: handleParams(params)}, config))
}



//////////////////
// WEBPACK FOOTER
// ./request/request.js
// module id = OaZ/
// module chunks = 53